export function copyAndRemoveEmptyEntries<T>(obj: T) {
  const copy: any = {
    ...obj,
  }
  Object.keys(copy).forEach(
    (key) => copy[key] === null || (copy[key] === '' && delete copy[key])
  )
  return copy
}
